<template>
  <div class="no-data-component">
    <slot name="icon" v-if="showIcon">
      <div class="tip-icon">
        <i :class="icon"></i>
      </div>
    </slot>
    <slot name="desc">
      <div class="tips">
        {{text}}
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'r2-icon-action_description'
    },
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="less" type="text/less" scoped>
  .no-data-component {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    user-select: none;
    pointer-events: none;
    .tip-icon {
      width: 56px;
      height: 56px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      text-align: center;
      line-height: 56px;
      i {
        color: rgba(255, 255, 255, 0.55);
        vertical-align: baseline;
        font-size: 22px;
      }
    }
    .tips {
      padding-top: 20px;
      height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.55);
      line-height: 22px;
    }
  }
</style>
